'use strict';

import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: 'enquiry', loadChildren: 'app/customizations/islington/enquiry/islington-enquiry.module#IslingtonEnquiryModule' },
  { path: 'book-now', loadChildren: 'app/customizations/islington/book-now/islington-book-now.module#IslingtonBookNowModule' },
  { path: '', redirectTo: 'book-now', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(
  routes,
  {
    useHash: true,
    //enableTracing: true
  });



// WEBPACK FOOTER //
// ./src/app/customizations/islington/app-islington.router.ts